class FreeShipping extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.update();
  }

  update(total_price) {
    const wrapper = this.querySelector('.js-free-shipping');
    if (!wrapper) return;

    const progressBar = wrapper.querySelector('.progress-bar');
    const textEl = this.querySelector('.js-free-shipping-text');

    const freeCost = Number(wrapper.dataset.cost);
    let cartTotal = Number(wrapper.dataset.value) / 100;
    const spendText = textEl.dataset.spend;
    const freeText = textEl.dataset.free;

    if (total_price) {
      cartTotal = total_price / 100;
    }

    let bar = Math.round((cartTotal / freeCost) * 100);
    bar = Math.min(bar, 100);

    if (bar >= 100) {
      textEl.innerHTML = freeText;
      progressBar.classList.add('free-progress-bar-100');
    } else {
      progressBar.classList.remove('free-progress-bar-100');

      const remaining = freeCost - cartTotal;
      const formattedPrice = new Intl.NumberFormat(
        Shopify.locale,
        { style: 'currency', currency: Shopify.currency.active }
      ).format(remaining);

      textEl.innerHTML = spendText.replace('%%', formattedPrice);
    }

    progressBar.style.width = `${bar}%`;
  }
}

customElements.define('cart-freeshipping', FreeShipping);